import { Radio, Button } from "antd";
import "./Invoices.scss";
import { nanoid } from 'nanoid';

const Invoice = ({ invoices, paymentMethod, setPaymentMethod, onPrint }) => {
  if (!invoices) return <p>No invoice data.</p>;

  const {
    Bill_ID,
    Date,
    Location,
    Item_Selected = [],
    Tax,
    originalTotal,
  } = invoices;

  const taxRate = parseFloat(Tax) / 100 || 0;
  const taxAmount = originalTotal * taxRate || 0;
  const finalTotal = originalTotal + taxAmount;

  const getRandomUperWords = (length = 12) => {
    return nanoid(length).toUpperCase();
  }

  const gerenrateQR =(toalAmount,Bill_ID) => {
    return `https://img.vietqr.io/image/MB-0001120490029-qr_only.png?amount=${toalAmount*26000}&addInfo=${Bill_ID}&accountName=Chau%20Hoai%20Vu`
  }

  const allItems = Item_Selected.flatMap((item) => {
    const itemRow = {
      name: item.name,
      price: item.price || 0,
      quantity: item.quantity || 0,
      total: item.total !== undefined ? item.total : (item.price || 0) * (item.quantity || 0),
      type: item.type,
    };
    const toppingRows =
      item.toppings?.map((t) => ({
        name: t.name,
        price: t.price || 0,
        quantity: t.quantity || 0,
        total: t.price || 0,
        type: "Topping",
      })) || [];
    return [itemRow, ...toppingRows];
  });

  const handlePaymentChange = (e) => {
    setPaymentMethod(e.target.value); // only one value
  };

  return (
    <div className="invoice-wrapper">
      <div className="invoice-container">
        <div className="invoice-main-content">
          <h2 className="invoice-title">PopPay System</h2>
          <p className="invoice-address">{Location}</p>
          <p className="invoice-phone">0338.998.047</p>
          <div className="invoice-divider" />

          <div className="invoice-header">
            <p className="invoice-date">{Date}</p>
            <h3>Invoice</h3>
            <p className="invoice-id">{Bill_ID}</p>
          </div>

          <table className="invoice-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Price</th>
                <th>Quantity</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              {allItems.map((item, index) => (
                <tr key={index} className={item.type === "Topping" ? "topping-row" : ""}>
                  <td>{item.name}</td>
                  <td>${item.price.toFixed(2)}</td>
                  <td>{item.quantity}</td>
                  <td>${item.total.toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="invoice-summary-container">
            {paymentMethod === "Bank" && <div className="qr_code">
              <img src={gerenrateQR(finalTotal,Bill_ID)} alt="QR Code" />
            </div>}
            <div className="invoice-summary">
              <p>Provisional: ${(originalTotal || 0).toFixed(2)}</p>
              <p>Tax: ${(taxAmount || 0).toFixed(2)}</p>
              <p className="invoice-total">
                Final Total: <strong>${(finalTotal || 0).toFixed(2)}</strong>
              </p>
            </div>
          </div>



        </div>

        <div className="invoice-footer">
          Thank you very much. We hope to see you again!
        </div>
      </div>

      <div className="invoice-actions">
        <Radio.Group
          options={["Cash", "Bank"]}
          onChange={handlePaymentChange}
          value={paymentMethod || null}
          optionType="button"
          buttonStyle="solid"
        />
        <Button
          type="primary"
          onClick={onPrint}
          style={{ marginLeft: 16, backgroundColor: "rgb(23, 226, 70)", borderColor: "rgb(23, 226, 70)" }}
        >
          Print / Process
        </Button>
      </div>
    </div>
  );
};

export default Invoice;
